// extracted by mini-css-extract-plugin
export default {"arrowLeft":"GDQ2_P","arrowRight":"Oltda_"};